/*eslint-disable*/
import api from '../'

class MotivationApi {
    // get: motivation/:id
    static show (id, type) {
        return api.axios.get('/motivation/' + id, {params: {type} }).then(response => response.data.motivation);
    }

    // put: motivation/:id
    static update (id, params) {
        return api.axios.put('/motivation/' + id, {type: params.type, data: params.data, points: params.points}).then(response => response.data.motivation);
    }

    // get: motivation-points/:id
    static getMotivationPoints (id, type) {
        return api.axios.get('/motivation-points/' + id, {params: {type} }).then(response => response.data.points);
    }
}

export default MotivationApi;
